import { useEffect, useRef } from 'react'

function useInterval(callback: () => unknown, delay: number, condition: boolean) {
    const intervalRef = useRef<null | number>(null)
    const savedCallback = useRef(callback)

    useEffect(() => {
        savedCallback.current = callback
    }, [callback])

    useEffect(() => {
        if (!condition) return

        const tick = () => savedCallback.current()
        if (typeof delay === 'number') {
            if ('requestIdleCallback' in window) {
                window.requestIdleCallback(tick)
            } else {
                tick()
            }
            intervalRef.current = window.setInterval(tick, delay)
        }
    }, [delay, condition])

    return intervalRef
}

export { useInterval }
